import Vue from 'vue'
import Router from 'vue-router'
import { store } from '../main.js'
import Home from './home'
import Login from './login'
import Admin from './admin'
import Profile from './profile'
import CategoryRecipe from './categoryRecipe'
import CategoryProduct from './categoryProduct'
import SubCategoryProduct from './subCategoryProduct'
import Recipe from './recipe'
import Ingredient from './ingredient'
import Equipment from './equipment'
import Product from './product'
import ContactUs from './contactUs'
import Configuration from './configuration'
import MaterialCategory from './materialCategory'
import Highlight from './highlight'
import CategoryVideo from './categoryVideo'
import ClassXRecipe from './questionClassRecipe'
import Video from './video'
import User from './user'
import ClassRecipe from './classRecipe'
import Tip from './tip'
import Download from './download'
import Promotional from './promotional'
import Exposition from './exposition'
import Curiosity from './curiosity'
import Notification from './notification'
import ProductOrder from './productOrder'
import CategoryProductOrder from './categoryProductOrder'
import RecipeOrder from './recipeOrder'
import CategoryRecipeOrder from './categoryRecipeOrder'
import DownloadOrder from './downloadOrder'
import TipOrder from './tipOrder'
import PromotionalOrder from './promotionalOrder'
import ExpositionOrder from './expositionOrder'
import CuriosityOrder from './curiosityOrder'
import MaterialCategoryOrder from './materialCategoryOrder'
import SubCategoryProductOrder from './subCategoryProductOrder'
import VideoOrder from './videoOrder'
import CategoryVideoOrder from './categoryVideoOrder'
import Question from './question'
import QuestionOrder from './questionOrder'
import Import from './import'
import PrivacyTerms from './privacyTerms'
import UseTerms from './useTerms'
import CookiesAccepted from './cookies_accepted'
Vue.use(Router);
const router = new Router({
    mode: 'history',
    linkActiveClass: "active",
    hashbang: false,
    routes: [
        Login,
        Home,
        Admin,
        Profile,
        CategoryRecipe,
        CategoryProduct,
        SubCategoryProduct,
        Recipe,
        Ingredient,
        Equipment,
        Product,
        ContactUs,
        Configuration,
        Tip,
        Download,
        Promotional,
        Exposition,
        Curiosity,
        MaterialCategory,
        MaterialCategoryOrder,
        Highlight,
        CategoryVideo,
        ClassXRecipe,
        Video,
        User,
        ClassRecipe,
        Notification,
        ProductOrder,
        CategoryProductOrder,
        RecipeOrder,
        CategoryRecipeOrder,
        DownloadOrder,
        TipOrder,
        PromotionalOrder,
        ExpositionOrder,
        CuriosityOrder,
        SubCategoryProductOrder,
        VideoOrder,
        CategoryVideoOrder,
        Question,
        QuestionOrder,
        Import,
        PrivacyTerms,
        UseTerms,
        CookiesAccepted
    ],
});
router.beforeEach((to, from, next) => {
    const authenticated = localStorage.getItem('token');
    const role_id = localStorage.getItem('role');
    if (authenticated && to.path.toString() != '/notification' && role_id == 5) {
        next('/notification');
    }
    if (!authenticated && to.path.toString() != '/login') {
        next('/login');
        return true;
    }
    if (authenticated && to.path.toString() == '/login') {
        next('/');
        return true;
    }
    next();
});
router.afterEach((to, from) => {
    $('#transition').slideUp();
});
export default router



// WEBPACK FOOTER //
// ./src/router/index.js